import { Link, Box, Typography } from '@mui/material';
import CustomImage from 'components/CustomImage';

export interface AlgoliaMainBannerProps {
  mainBanner?: {
    link?: { url?: string };
    image?: {
      title?: string;
      urls?: { url: string }[];
    };
    type?: string;
  };
  isMobile?: boolean;
}

const AlgoliaMainBanner = ({ mainBanner, isMobile = false }: AlgoliaMainBannerProps) => {
  if (!mainBanner || !mainBanner.image?.urls?.[0]?.url) return null;

  const { link, image } = mainBanner;
  const imageUrl = image.urls[0].url;
  const imageTitle = image.title || 'Banner image';
  const bannerHeight = isMobile ? '145px' : '156px';
  const bannerSpacing = isMobile ? '0.5rem' : '0.9rem';
  const fontSize = isMobile ? '0.625rem' : '0.875rem';

  return (
    <Link target="_blank" href={link?.url} data-testid="algolia-main-banner-link" sx={{ mb: bannerSpacing }}>
      <Box
        data-testid="algolia-main-banner-wrapper"
        sx={{
          position: 'relative',
          height: bannerHeight,
        }}
      >
        <CustomImage
          src={imageUrl}
          alt={imageTitle}
          fill
          sizes="100vw"
          unoptimized
          data-testid="algolia-main-banner-image"
          sx={{ objectFit: 'cover' }}
        />
        <Box
          data-testid="algolia-main-banner-title-wrapper"
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: '#FFFFFFB2',
            p: 0.625,
          }}
        >
          <Typography
            variant="h6"
            component="p"
            data-testid="algolia-main-banner-title"
            sx={{
              fontSize,
              color: '#212B36',
            }}
          >
            {imageTitle}
          </Typography>
        </Box>
      </Box>
    </Link>
  );
};

export default AlgoliaMainBanner;
